import { render, staticRenderFns } from "./investigation-register-details.vue?vue&type=template&id=11576c48&"
import script from "./investigation-register-details.vue?vue&type=script&lang=js&"
export * from "./investigation-register-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports